import {
    Injectable,

    Injector,
    InjectionToken,
    Type,
    ComponentRef,
    ComponentFactory,
    ComponentFactoryResolver
} from '@angular/core';

import { tap } from 'rxjs/operators';

import { ToastComponent } from './toast.component';
import { ToastrRef } from './toastr.ref';
import { ToastRef } from './toast-ref';

export const TOAST_DATA = new InjectionToken<any>('ToastData');

interface IToastConfig {
    actions?: boolean;
    timeout?: number;
    data: any;
}

const TOAST_ACTIONS = true;
const TOAST_TIMEOUT = 3000;

const CONTENT_SELECTOR = '.__content';
const CONTAINER_SELECTOR = '.__container';

@Injectable()
export class ToastrService {
    constructor(
        private _toastrRef: ToastrRef,
        private _injector: Injector,
        private _resolver: ComponentFactoryResolver
    ) {
    }

    show<T>(Component: Type<T>, config: IToastConfig) {
        const toastRef = new ToastRef<T>();
        const injector = this._createInjector(toastRef, config.data);

        // const toast = this._createComponent(ToastComponent, injector, this._toastrRef.elementRef.nativeElement);
        const toast = this._createComponent(ToastComponent, injector);

        toast.instance.actions = TOAST_ACTIONS;
        if (config && typeof config.actions !== 'undefined') {
            toast.instance.actions = config.actions;
        }

        toast.instance.timeout = TOAST_TIMEOUT;
        if (config && typeof config.actions !== 'undefined') {
            toast.instance.timeout = config.timeout;
        }

        toast.instance.close.pipe(tap(($event) => toastRef.close($event)))
            .subscribe();

        toast.changeDetectorRef.detectChanges();
        toast.changeDetectorRef.markForCheck();

        toast.location.nativeElement.classList.add('--show');

        const nested = toast.instance.viewContainerRef.createComponent(
            this._resolver.resolveComponentFactory(Component)
        );
        nested.changeDetectorRef.detectChanges();

        const intervalId = setInterval(() => {
            toast.changeDetectorRef.detectChanges();
            nested.changeDetectorRef.detectChanges();
        }, 10);
        // nested.changeDetectorRef.markForCheck();

        this._toastrRef.push(toast);

        toastRef.instance = nested.instance;
        toastRef.close$.pipe(tap(() => this._toastrRef.pull(toast)))
            .pipe(tap(() => clearInterval(intervalId)))
            .subscribe();

        return toastRef;
    }

    _createInjector<T>(toastRef: ToastRef<T>, data: any) {
        return Injector.create({
            parent: this._injector,
            providers: [
                { provide: TOAST_DATA, useValue: data },
                { provide: ToastRef, useValue: toastRef }
            ]
        });
    }

    _createComponent<T>(Component: Type<T>, injector: Injector, root: any = null): ComponentRef<T> {
        return this._resolver
            .resolveComponentFactory(Component)
            .create(injector, [], root);
    }
}

function $(s: string, p: HTMLElement | Document = document) {
    return p.querySelector(s);
}

function append<T, R>(
    childRef: ComponentRef<T>,
    parentRef: ComponentRef<R>,
    selector: string = CONTENT_SELECTOR
) {
    const container = $(selector, parentRef.location.nativeElement);

    container.appendChild(childRef.location.nativeElement);
}
